import type { Theme } from '@mui/material';
import { styled, Typography } from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
  minHeight: '44px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  transition: theme.transitions.create('border-color', { duration: theme.transitions.duration.shortest }),
  '&:hover': {
    borderColor: theme.palette.grey[400],
  },
}));

export const Header = styled('div')(({ theme, mock }: { theme?: Theme; mock: string }) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  minWidth: 0,
  cursor: mock !== 'true' ? 'pointer' : 'default',
  '&:hover > div': {
    transform: mock !== 'true' ? 'translateX(3px)' : 'none',
  },
  '&:hover .card-title': {
    color: mock !== 'true' ? theme?.palette.primary.main : undefined,
  },
  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    transition: theme?.transitions.create('transform', { duration: 150 }),
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  transition: theme.transitions.create('color', { duration: theme.transitions.duration.shortest }),
}));

export const Count = styled(Typography)(() => ({
  flexShrink: 1,
  fontWeight: 500,
}));

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

export const ButtonWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'isPlainIcon',
})<{ disabled: boolean; isPlainIcon?: boolean }>(({ theme, disabled, isPlainIcon }) => ({
  width: '30px',
  height: '30px',
  borderRadius: isPlainIcon ? 0 : '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: isPlainIcon ? 'transparent' : theme?.palette.grey[100],
  cursor: disabled ? 'default' : 'pointer',
  flexShrink: 0,
  transition: theme?.transitions.create('background-color', { duration: theme?.transitions.duration.shortest }),
  '&:hover': {
    backgroundColor: isPlainIcon ? 'transparent' : disabled ? theme?.palette.grey[100] : theme?.palette.grey[200],
  },
  '& > button > svg': {
    fill: theme?.palette.primary.main,
  },
  [theme!.breakpoints.down('md')]: {
    width: '26px',
    height: '26px',
  },
}));
